import React from 'react'
import "./Subtotal.css"
import CurrencyFormat from 'react-currency-format'
import { useStateValue } from '../StateProvider'
import { getCartTotal } from '../Reducer'

function Subtotal() {
    const [{ cart }] =useStateValue()
    return (
        <div className="subtotal">
            <CurrencyFormat
                renderText={(value) => (
                    <>
                        <p>
                            Subtotal ({cart.length} items): <strong>{
                                                        new Intl.NumberFormat('en-IN', {
                                                        style: 'currency',
                                                        currency: 'INR'}).format(getCartTotal(cart))
                                                    }</strong>
                        </p>
                        <small className="subtotal__gift">
                            <input type= "checkbox" /> Does this Order contain a gift?
                        </small>
                    </>
                )}
                demiScale={2}
                value={getCartTotal(cart)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"₹"}
            />
            <button>proceed to checkout</button>
        </div>
    )
}


export default Subtotal
